import React from "react";
/* import AddProjectForm from "./AddProjectForm"; */
import { TEXT_LABELS } from "../../../common/configTable";
import MUIDataTable from "mui-datatables";
import { Typography, Tooltip } from "@material-ui/core";
import ThemeContainer from "../../../common/ThemeProvider";

const RequirementsTableI = ({
  openModalEliminar,
  plannedBudget,
  executedBudget,
  component,
  datas,
  activities,
  populateRequirements,
}) => {
  const columns = [
    {
      name: "count",
      label: "ID",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1,
      },
    },
    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        display: "excluded",
      },
    },
    {
      name: "updated_at",
      label: "Fecha Actualización",
      options: {
        filter: false,
        display: "excluded",
      },
    },
    {
      name: "type",
      label: "Tipo compra",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Nombre",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "code_cpc",
      label: "Código CPC",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "cuatrimestre1",
      label: "Cuatrimestre",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "porcentajec1",
      label: "Porcentaje - I",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "cuatrimestre2",
      label: "Cuatrimestre",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "porcentajec2",
      label: "Porcentaje - II",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "cuatrimestre3",
      label: "Cuatrimestre",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "porcentajec3",
      label: "Porcentaje - III",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "quantity",
      label: "Cantidad",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "price",
      label: "Precio ($)",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "iva",
      label: "IVA %",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "total_price",
      label: "Total ($)",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "activity_name",
      label: "Actividad",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "human_updated_at",
      label: "Última Actualización",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <React.Fragment>
              <Tooltip
                title={`${tableMeta.rowData[2]}`}
                style={{ cursor: "pointer" }}
              >
                <span>{`${value}`}</span>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
  ];
  const options = {
    /* search: false,
    print: false,
    download: false,
    filter: false,
    viewColumns: false, */
    enableNestedDataAccess: [],
    sort: true,
    searchPlaceholder: "Buscar",
    filterType: "dropdown",
    responsive: "scroll",
    rowsPerPage: 20,
    rowsPerPageOptions: [5, 10, 20],
    selectableRows: "none",
    textLabels: TEXT_LABELS,
    //selectableRows: "single",
    /* onRowsDelete: (rowsDeleted) => {
      const items = datas; //lista de todos los proyectos
      const itemsToDelete = rowsDeleted.data.map(
        (item) => items[item.dataIndex]
      ); //Array de todos los proyectos a borrar.
      this.props.onDelete(itemsToDelete);
    }, */
  };

  return (
    <ThemeContainer>
      <MUIDataTable
        title={
          <>
            <Typography variant="h6">Lista de requerimientos</Typography>
            <div className="separate"></div>
          </>
        }
        data={datas}
        columns={columns}
        options={options}
        responsive={"scrollFullHeight"}
      />
    </ThemeContainer>
  );
};

export default RequirementsTableI;
